// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary {
  margin-left: 10px !important;
}

.secondary {
  margin-left: 5px;
}

.required-marker {
  color: #ff0000;
  font-size: 0.8em;
  font-weight: bolder;
}

.uploadFileContainer {
  height: 140px;
  width: 100%;
  border: 2px dashed var(--theme-main-border-color, #055C8D);
  border-radius: 10px;
}

.drag-drop-label {
  color: gray;
}

.la-cloud-upload-alt {
  font-size: 5rem;
}

.uploadfilecontainer:hover {
  cursor: pointer;
  background-color: #9ecbec !important;
  opacity: 0.8;
}

.files-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 6px;
  background: #ffffff;
  border: 1px dashed;
  border-radius: 12px;
  color: var(--theme-main-color, #055C8D);
}

.files-list .delete-file {
  background: transparent;
  border: none;
  cursor: pointer;
}

.files-list .delete-file img {
  width: 30px;
}

.la-trash-alt {
  color: red;
}

.uploader-height {
  height: 200px;
}

.error-message-div {
  height: 20px;
}

.error-message {
  color: #ff0000;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
